import styled from "styled-components";

// Styling for the Heading Component.
const Heading = styled.h1`
  font-size: 3rem;
  color: #8a5ebf;
  text-align: center;
  margin: 35px;
  margin-bottom: 10px;
  @media screen and (max-width: 600px) {
    font-size: 2.5rem;
  }
`;
// Styling for the Paragraph Component.
const Paragraph = styled.p`
  font-size: 1.5rem;
  color: #8a5ebf;
  text-align: center;
  padding: 10px;
  max-width: 50%;
  margin: auto;
  @media screen and (max-width: 600px) {
    font-size: 1.2rem;
    max-width: 80%;
  }
`;
// Styling the Div Component.
const Div = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 600px) {
    flex-direction: column;
  }
`;
// Styling the PlacementDiv Component.
const PlacementDiv = styled.div`
  background: rgb(238, 109, 152);
  background: linear-gradient(
    0deg,
    rgba(238, 109, 152, 1) 48%,
    rgba(138, 94, 191, 1) 92%
  );
  margin: 30px 0;
  width: 50%;
  height: 300px;
  max-width: 300px;
  border-radius: 15px;
  text-align: center;
  color: #fff;
  padding: 10px;
  @media screen and (max-width: 600px) {
    width: 80%;
    max-width: 400px;
  }
`;
// Styling the InternDiv Component.
const InternDiv = styled.div`
  color: #8a5ebf;
  text-align: center;
  padding: 20px;
  border: 2px dashed #8a5ebf;
  border-radius: 10px;
  border-left: 0;
  height: 250px;
  max-width: 300px;
  width: 45%;
  transform: translateX(-10px);
  @media screen and (max-width: 600px) {
    border: 2px dashed #8a5ebf;
    margin: auto;
    transform: translateX(0) translateY(-35px);
    border-top: 0;
    width: 70%;
  }
`;
// Styling the Svg Component.
const Svg = styled.img`
  display: none;
  @media screen and (min-width: 1000px) {
    display: block;
    width: 400px;
    height: 400px;
    margin: 50px;
    transform: translateY(50px);
  }
`;

export { Heading , Paragraph , Div, PlacementDiv, InternDiv, Svg };
